// src/utils/helpers.js

/**
 * Convert a product name to a URL slug.
 * e.g. "Urvaraa Vermicompost" → "urvaraa-vermicompost"
 */
export function toSlug(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .trim();
}

/**
 * Truncate a string to a given length, adding "..." if cut.
 */
export function truncate(str, maxLen = 120) {
  if (!str) return "";
  return str.length <= maxLen ? str : str.substring(0, maxLen).trimEnd() + "...";
}

/**
 * Format a Firestore Timestamp or JS Date into a readable string.
 */
export function formatDate(timestamp) {
  if (!timestamp) return "";
  const date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/**
 * Build a mailto link with subject and body pre-filled.
 */
export function buildMailtoLink(email, subject, body = "") {
  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

/**
 * Build a WhatsApp link with a pre-filled message.
 * phoneNumber should include country code, e.g. "919876543210"
 */
export function buildWhatsAppLink(phoneNumber, message = "") {
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
}

/**
 * Simple email validator.
 */
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Scroll smoothly to an element by ID.
 */
export function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

/**
 * Group an array of objects by a key.
 * e.g. groupBy(products, "category")
 */
export function groupBy(arr, key) {
  return arr.reduce((acc, item) => {
    const group = item[key] || "Other";
    if (!acc[group]) acc[group] = [];
    acc[group].push(item);
    return acc;
  }, {});
}
